/**
 * 제품 상세 — 목록의 줄을 눌러 새 탭으로 여는 한 장. 백엔드 GET /api/admin/products/:id (2026-10-14 실데이터. 배치 다시 그림 2026-10-14 저녁 — 현민 "레이아웃과 배치 다 완벽했으면").
 * 머리(PN · 디스크립션 · 칩 셋 · 제품번호 · 버튼 자리) / 왼쪽 ⅔: 기본 정보 · 스펙 · 구성(set) · 섀시(server) / 오른쪽 ⅓: 재고 요약 · 메모 · 이력.
 * 재고 요약의 수는 그 product 의 실물 묶음에서 센다(받기만, 표는 없다 — 줄은 재고 현황의 몫. 현민 2026-10-14 밤 "지우는게 낫겟지"). 컨디션 × 상태 합산 표도 재고 현황(회의 2026-10-08). 수정 · 단종 · 메모 편집 · 이력(승격 · 견적 사용)은 자리만 — 다음.
 * 글자 셋 — 머리글 · 본문 13px 진한 · 보조 12px 회색(VOCABULARY "시안 표의 글자 셋").
 */

import { SolaView, htmlSolaWithInstance } from '@hm-spt/sola';
import { ROW_NO_HEAD, rowNoCell } from '../components/row-no';
import { SPEC_CATEGORIES } from '@hcltech/shared/server-config/spec-category';
import type { SpecCategory } from '@hcltech/shared/server-config/spec-category';
import * as api from '../api/client';
import type { ProductCatalogView, ProductDetail, ProductHistoryEntry, ProductItemView, ProductRef, ProductUpdateInput, UnitView, UnitViewList, EPartNumberKind } from '../api/client';
import { assert } from '../lib/assert';
import { CATALOG_LINK_WORD, CATALOG_TABLE_WORD, E_PART_NUMBER_KINDS, PART_NUMBER_KIND_WORD, PRODUCT_SHAPE_WORD, productShapeOf } from '../api/client';
import { escapeHtml } from '../lib/cells';
import { openMergeDialog } from '../components/merge-dialog';
import { columnLabelOf } from './catalog-requests/form';

/** 수정 폼 — 글만 쥔다(폼 ↔ 입력은 saveInputOf 가 변환). null = 읽기 상태. option_part 는 미연결 파트만 고친다(PN 정정, 2026-10-15) */
interface EditForm { option_part: string; pn_kind: EPartNumberKind; description: string; notes: string; search_text: string; spec_category: string; spare_part: string; assembly_part: string; vendor: string }   // pn_kind · 스페어 · 어셈블리 · 제조사는 미연결 파트만 쓴다(2026-10-20)

/** PN 정정 칸 밑 한 줄 — 칸을 벗어날 때 서버에 물어본 결과. same = 안 바뀜(아무것도 안 보임) */
type PnCheck =
  | { kind: 'same' }
  | { kind: 'checking' }
  | { kind: 'taken'; product: ProductRef }      // 같은 PN 의 다른 제품 — 저장을 막는다
  | { kind: 'link'; description: string | null; option_part: string | null }   // 카탈로그에 있음 — 저장하면 연결. option_part 는 스페어 · 어셈블리로 찾았을 때 그 행의 옵션 PN(2026-10-20)
  | { kind: 'request' }                         // 카탈로그에 없음 — 저장하면 새 요청
  | { kind: 'failed'; message: string };

interface ProductDetailData {
  id: string;                       // hclt_product.id — BIGINT 라 글
  detail: ProductDetail | null;     // 받은 한 장. null = 아직 · 못 받음
  units: UnitViewList | null;       // 그 product 의 실물 한 묶음(product_id 필터). null = 아직 · 못 받음
  loading: boolean;
  error: string;                    // '' = 없음. 404 면 "없는 제품"
  edit: EditForm | null;            // [수정] 누른 뒤의 폼. null = 읽기
  saving: boolean;
  saveError: string;                // 저장 실패 글. '' = 없음
  pnCheck: PnCheck;                 // PN 정정 칸의 조회 결과
}

/** 재고 요약 — 실물 줄에서 센 것. 총합 = 지금 우리 손에 있는 갈래 다섯의 합(가용 · 세팅됨 · 검수 중 · 임대 · 자산). 출고 · 이탈은 없는 것이라 안 센다(현민 2026-10-14). 자산은 2026-10-30 */
interface StockSummary { total: number; available: number; reserved: number; inspecting: number; rented: number; asset: number }

const NOT_FOUND_PREFIX = 'HTTP 404';   // getJson 이 던지는 글의 머리 — 없는 제품
const INVENTORY_HREF = '/preview/inventory/units';   // 실물 탭 — 검수 · 이동은 거기서
const REQUESTS_HREF = '/catalog-entry/requests/requested';   // 요청 id 를 모를 때의 폴백(요청됨 탭)

/** 요청 중인 제품의 요청함 주소 — 그 PN 의 열린 요청 상세(새 탭). id 가 없으면 요청됨 탭 */
function requestHrefOf(detail: ProductDetail): string {
  return detail.catalog_pending_id === null ? REQUESTS_HREF : `/catalog-entry/requests/${detail.catalog_pending_id}`;
}
const CHASSIS_CATEGORY: SpecCategory = 'CHASSIS';
/** 파트 카테고리 — 21종에서 섀시 뺀 것(제품 등록 폼과 같은 규칙) */
const PART_CATEGORIES: readonly SpecCategory[] = SPEC_CATEGORIES.filter((category) => category !== CHASSIS_CATEGORY);
// 제조사 셀렉트의 후보 — 카탈로그 철자 그대로(V장 "파트넘버" 벤더 표 + 카탈로그 · 제품에 실제 있는 것). 밖의 것은 '기타' 로 글을 친다(현민 2026-10-20)
const VENDOR_CHOICES: readonly string[] = ['HPE', 'Dell', 'Lenovo', 'Samsung', 'SK Hynix', 'Micron', 'Seagate', 'Intel', 'Broadcom', 'NVIDIA', 'IBM', 'Oracle', 'Synology', 'Fujitsu'];
const VENDOR_OTHER = '__other__';   // 셀렉트의 '기타' 값 — 글 칸이 열린다
const PN_TAKEN_WORD = '같은 파트넘버의 제품이 이미 있어 저장할 수 없습니다';
const PN_EMPTY_WORD = '파트넘버를 비울 수는 없습니다';
const PN_KEY_PATTERN = /\s+/g;

export class ProductDetailView extends SolaView<ProductDetailData> {
  override events = {
    click:  { '@edit': 'handleEdit', '@cancel': 'handleCancel', '@save': 'handleSave', '@pn-merge': 'handlePnMerge' },
    input:  { '@field': 'handleField', '@pn': 'handlePnInput' },
    change: { '@field': 'handleField', '@active': 'handleActive', '@pn': 'handlePnCheck', '@pn-kind': 'handlePnKind', '@vendor-choice': 'handleVendorChoice' },
  };

  constructor(params: { id: string }) {
    super();
    this.data = { id: params.id, detail: null, units: null, loading: true, error: '', edit: null, saving: false, saveError: '', pnCheck: { kind: 'same' } };
  }

  override getTitle(): string {
    const detail = this.data.detail;
    const name = detail === null ? '없는 제품' : detail.option_part === null ? detail.hclt_number : detail.option_part;
    return `${name} — 제품 상세 — HCLTech`;
  }

  override onMount(): void {
    void this.load();
  }

  render(): HTMLElement {
    return htmlSolaWithInstance(this)`
      <div class="page page-product-detail pv-page">
        <header class="page-header">
          <h1>📋 제품 상세</h1>
          <a class="btn-ghost" data-link href="/products">목록으로</a>
        </header>
        <section class="page-body pv-body">${this.renderBody()}</section>
      </div>`;
  }

  // ─── 불러오기 ───
  /** 한 장 + 그 product 의 실물. 상세가 실패면(404 는 "없는 제품") 실물은 안 부른다. 끝나면 본문 다시 그림 */
  private async load(): Promise<void> {
    this.data = { ...this.data, loading: true, error: '' };
    this.refreshRegion('.pv-body', () => this.renderBody());
    try {
      const detail = await api.fetchProduct(this.data.id);
      const units = await api.fetchUnits({ status: '', q: '', show_gone: false, product_id: this.data.id, offset: 0 });
      this.data = { ...this.data, detail, units, loading: false };
    } catch (e) {
      this.data = { ...this.data, loading: false, error: e instanceof Error ? e.message : String(e) };
    }
    this.refreshRegion('.pv-body', () => this.renderBody());
  }

  // ─── 본문 ───
  /** 상태 셋 갈림 — 불러오는 중 · 못 받음(없는 제품 / 그 밖) · 한 장 */
  private renderBody(): string {
    const { detail, loading, error } = this.data;
    if (loading) return '<p class="text-muted">불러오는 중…</p>';
    if (error.startsWith(NOT_FOUND_PREFIX)) return `<p class="text-muted">없는 제품입니다 — #${escapeHtml(this.data.id)}</p>`;
    if (error !== '') return `<p class="text-muted">불러오지 못했습니다 — ${escapeHtml(error)}</p>`;
    if (detail === null) return '';
    return `
      ${this.renderHead(detail)}
      <div class="pd-layout">
        <div class="pd-main">
          ${this.renderBasics(detail)}
          ${this.renderCatalog(detail)}
          ${this.renderItems(detail)}
        </div>
        <aside class="pd-side">
          ${this.renderStock(detail)}
          ${this.renderNotes(detail)}
          ${this.renderHistory(detail)}
        </aside>
      </div>`;
  }

  /** 머리 — 본문: 파트넘버(굵게) · 디스크립션. 칩 셋: 타입 · 카테고리 · 카탈로그. 오른쪽: 제품번호 + 버튼 자리([수정] [단종] — 다음) */
  private renderHead(detail: ProductDetail): string {
    const link = detail.catalog;
    const chipClass = link === 'linked' ? 'chip-success' : link === 'requested' ? 'chip-warning' : 'chip-muted';
    return `
      <div class="form-card pd-head">
        <div class="pd-head-row">
          <div class="pd-title">
            <span class="pd-pn mono">${detail.option_part === null ? '—' : escapeHtml(detail.option_part)}</span>
            <span class="pd-desc">${detail.description === null ? '<span class="text-muted">설명 없음</span>' : escapeHtml(detail.description)}</span>
          </div>
          <div class="pd-head-right">
            <span class="pl-id mono">${escapeHtml(detail.hclt_number)}</span>
            ${this.renderHeadButtons()}
          </div>
        </div>
        <div class="pd-chips">
          <span class="chip chip-muted">${PRODUCT_SHAPE_WORD[productShapeOf(detail.items.length)]}</span>
          ${detail.spec_category === null ? '' : `<span class="chip chip-muted">${escapeHtml(detail.spec_category)}</span>`}
          ${link === 'requested'
            ? `<a class="chip ${chipClass} pd-chip-link" href="${requestHrefOf(detail)}" target="_blank" rel="noopener" title="이 파트넘버의 카탈로그 요청(새 탭)">카탈로그 ${CATALOG_LINK_WORD[link]} ↗</a>`
            : `<span class="chip ${chipClass}">카탈로그 ${CATALOG_LINK_WORD[link]}</span>`}
          ${detail.is_active ? '' : '<span class="chip chip-warning">단종 · 숨김</span>'}
        </div>
      </div>`;
  }

  /** 머리 버튼 — 읽기: [수정]. 수정 중: 오류 글 · [취소] [저장] */
  private renderHeadButtons(): string {
    const { edit, saving, saveError } = this.data;
    if (edit === null) return '<button type="button" class="btn-ghost" data-action="edit">수정</button>';
    return `
      ${saveError === '' ? '' : `<span class="pc-error">${escapeHtml(saveError)}</span>`}
      <button type="button" class="btn-ghost" data-action="cancel" ${saving ? 'disabled' : ''}>취소</button>
      <button type="button" class="btn-primary" data-action="save" ${saving ? 'disabled' : ''}>${saving ? '저장 중…' : '저장'}</button>`;
  }

  /** 기본 정보 — product 행의 칸을 2열 표로. 제조사는 카탈로그가 준 값. 모델 칸은 뺐다(회의 2026-10-21 §4 — 파트넘버 · 디스크립션에 들어 있다). 수정 중이면 고치는 칸이 입력으로 */
  private renderBasics(detail: ProductDetail): string {
    const edit = this.data.edit;
    if (edit !== null) return this.renderBasicsForm(detail, edit);
    const categoryRows: [string, string][] = detail.type === 'server' ? [] : [['카테고리', detail.spec_category === null ? '—' : escapeHtml(detail.spec_category)]];   // 서버엔 카테고리가 없다 — 줄을 안 그린다(2026-10-20)
    const rows: [string, string][] = [
      ['제조사', detail.vendor === null ? '—' : escapeHtml(detail.vendor)],
      ...categoryRows,
      ['검색어', detail.search_text === null || detail.search_text.trim() === '' ? '—' : escapeHtml(detail.search_text)],
      ['사용 여부', renderActiveRadios(detail.is_active, this.data.saving)],   // 읽기에서 바로 — 누르면 저장(현민 2026-10-14 "수정 누르고 하기보다")
      ['등록', `${detail.created_by === null ? '—' : escapeHtml(detail.created_by)} · <span class="mono">${escapeHtml(detail.created_at.slice(0, 10))}</span>`],
      ['제품번호', `<span class="mono">${escapeHtml(detail.hclt_number)}</span>`],
    ];
    return `
      <section class="form-card pd-card">
        <h2>기본 정보 <small>이 product 가 무엇인가 — 파는 단위의 칸</small></h2>
        <div class="pd-kv-grid">${rows.map(([key, value]) => `<div class="kv-row"><span class="kv-key">${key}</span><span class="kv-val">${value}</span></div>`).join('')}</div>
      </section>`;
  }

  /** 기본 정보 — 수정 폼. 제조사 · 제품번호 · 등록은 읽기 그대로(카탈로그 · 시스템 값), 나머지는 입력. 카테고리는 파트만. 모델 칸 없음(2026-10-22) */
  private renderBasicsForm(detail: ProductDetail, edit: EditForm): string {
    const categoryCell = detail.type === 'server'
      ? '<span class="text-muted">— (서버엔 없음)</span>'
      : detail.type === 'part' && detail.catalog === 'linked'
      ? `${detail.spec_category === null ? '—' : escapeHtml(detail.spec_category)} <small class="text-muted">카탈로그 표의 것 — 바꾸려면 카탈로그에서 카테고리 옮기기</small>`
      : `<select data-action="field" data-key="spec_category" class="pd-input">
           <option value="" ${edit.spec_category === '' ? 'selected' : ''}>—</option>
           ${PART_CATEGORIES.map((item) => `<option value="${item}" ${edit.spec_category === item ? 'selected' : ''}>${item}</option>`).join('')}
         </select>`;
    const text = (key: keyof EditForm, value: string, placeholder: string): string =>
      `<input type="text" class="pd-input" data-action="field" data-key="${key}" value="${escapeHtml(value)}" placeholder="${placeholder}">`;
    const bOpenSpecs = isSpecsOpen(detail);   // 미연결 파트 — 카탈로그가 줄 값이 없어 사람이 적는다(specs)
    return `
      <section class="form-card pd-card pd-editing">
        <h2>기본 정보 <small>수정 중 — 카탈로그 값은 안 바뀐다. 파트넘버 · 제조사 · 스페어 · 어셈블리는 미연결 파트만</small></h2>
        <div class="pd-kv-grid">
          <div class="kv-row"><span class="kv-key">파트넘버</span><span class="kv-val">${this.renderPnCell(detail, edit)}</span></div>
          <div class="kv-row"><span class="kv-key">디스크립션</span><span class="kv-val">${detail.catalog === 'linked' ? `${escapeHtml(edit.description)} <small class="text-muted">카탈로그가 준 설명 — 카탈로그에서 고칩니다</small>` : text('description', edit.description, '파는 단위의 한 줄')}</span></div>
          <div class="kv-row"><span class="kv-key">제조사</span><span class="kv-val pd-vendor-cell">${bOpenSpecs ? renderVendorCell(edit.vendor) : (detail.vendor === null ? '—' : escapeHtml(detail.vendor))}</span></div>
          ${bOpenSpecs ? `<div class="kv-row"><span class="kv-key">스페어 넘버</span><span class="kv-val">${text('spare_part', edit.spare_part, '서비스 교체 번호 — 873594-001')}</span></div>
          <div class="kv-row"><span class="kv-key">어셈블리 넘버</span><span class="kv-val">${text('assembly_part', edit.assembly_part, '기판 번호 — 752369-081')}</span></div>` : ''}
          ${detail.type === 'server' ? '' : `<div class="kv-row"><span class="kv-key">카테고리</span><span class="kv-val">${categoryCell}</span></div>`}
          <div class="kv-row"><span class="kv-key">검색어</span><span class="kv-val">${text('search_text', edit.search_text, '별칭 · 통칭 한 줄')}</span></div>
          <div class="kv-row"><span class="kv-key">등록</span><span class="kv-val">${detail.created_by === null ? '—' : escapeHtml(detail.created_by)} · <span class="mono">${escapeHtml(detail.created_at.slice(0, 10))}</span></span></div>
          <div class="kv-row"><span class="kv-key">제품번호</span><span class="kv-val"><span class="mono">${escapeHtml(detail.hclt_number)}</span></span></div>
        </div>
      </section>`;
  }

  /** 파트넘버 칸 — 미연결 파트만 입력(PN 정정). 연결된 파트는 잠근 글, 서버 · 세트는 PN 이 제품의 것이 아니라 글만 */
  private renderPnCell(detail: ProductDetail, edit: EditForm): string {
    const current = detail.option_part === null ? '—' : escapeHtml(detail.option_part);
    if (detail.type !== 'part') return `<span class="mono">${current}</span>`;
    if (detail.catalog === 'linked') return `<span class="mono">${current}</span> <small class="text-muted">카탈로그에 연결돼 고칠 수 없습니다</small>`;
    const kinds = E_PART_NUMBER_KINDS.map((kind) => `<option value="${kind}" ${edit.pn_kind === kind ? 'selected' : ''}>${PART_NUMBER_KIND_WORD[kind]}</option>`).join('');
    return `
      <span class="pd-pn-kind"><select class="pd-input pd-input-short" data-action="pn-kind">${kinds}</select>
      <input type="text" class="pd-input mono" data-action="pn" value="${escapeHtml(edit.option_part)}" placeholder="P00924-B21 · MZ-7L348000" autocomplete="off"></span>
      <div class="pd-pn-hint">${renderPnCheck(this.data.pnCheck)}</div>`;
  }

  /** 스펙 — 카탈로그 행의 핵심 열(ADMIN_TABLES.sortable)만 + PN 넷 한 줄. 전부는 카탈로그에서(링크가 그 PN 으로 연다). 요청 중이면 요청함 링크, 없으면 한 줄 글 */
  private renderCatalog(detail: ProductDetail): string {
    const part = detail.catalog_part;
    if (part === null) {
      const word = detail.catalog === 'requested'
        ? `카탈로그에 아직 없습니다 — 조사 · 컨펌 중. <a class="pd-link" href="${requestHrefOf(detail)}" target="_blank" rel="noopener">요청 보기 ↗</a>`
        : '카탈로그에 없고 요청도 없습니다.';
      return `
        <section class="form-card pd-card">
          <h2>스펙</h2>
          <p class="text-muted">${word}</p>
        </section>`;
    }
    const catalogHref = `/catalog?q=${encodeURIComponent(part.option_part)}&table=${encodeURIComponent(part.table_name)}`;   // 전체 검색이 그 줄의 드로어를 연다 — 표를 옮겨도 PN 으로 찾는다(2026-10-20)
    return `
      <section class="form-card pd-card">
        <h2>스펙 <small>카탈로그의 핵심 칸만 <span class="chip chip-muted">${CATALOG_TABLE_WORD[part.table_name]}</span></small></h2>
        <div class="pd-kv-grid">
          <div class="kv-row"><span class="kv-key">파트넘버</span><span class="kv-val"><b class="mono">${escapeHtml(part.option_part)}</b></span></div>
          ${this.otherPartNumberRow('스페어 넘버', part.spare_part)}
          ${this.otherPartNumberRow('어셈블리 넘버', part.assembly_part)}
        </div>
        ${this.renderSpecs(part)}
        <a class="pd-link" data-link href="${catalogHref}">카탈로그에서 보기 →</a>
      </section>`;
  }

  /** 옵션 말고 다른 번호 한 줄 — 없으면 줄째 안 보인다. FIO 는 안 보인다(회의 2026-10-15 "팩토리는 안 보여도 될 것 같아") */
  private otherPartNumberRow(label: string, partNumberOrNull: string | null): string {
    if (partNumberOrNull === null) return '';
    return `<div class="kv-row"><span class="kv-key">${label}</span><span class="kv-val mono">${escapeHtml(partNumberOrNull)}</span></div>`;
  }

  /** 스펙 칸 — 값 있는 열만, 라벨은 DDL 주석 첫 문장(없으면 열 이름) */
  private renderSpecs(part: ProductCatalogView): string {
    if (part.specs.length === 0) return '<p class="text-muted">스펙 칸이 비어 있습니다</p>';
    return `
      <div class="pd-specs">
        ${part.specs.map((spec) => `
          <div class="kv-row">
            <span class="kv-key">${escapeHtml(columnLabelOf(spec))}${spec.comment === null ? '' : `<span class="kv-key-raw">${escapeHtml(spec.name)}</span>`}</span>
            <span class="kv-val">${escapeHtml(spec.value)}</span>
          </div>`).join('')}
      </div>`;
  }

  /** 구성 — set 은 파트 product 줄들. server 는 섀시 한 줄뿐 — 구성은 재고(실물 나무) 몫(2026-10-19) */
  private renderItems(detail: ProductDetail): string {
    if (detail.type === 'part') return '';
    if (detail.type === 'server') return `
      <section class="form-card pd-card">
        <h2>섀시 <small>서버 제품 = 섀시 SKU 하나. 구성은 실물마다 다르다 — 재고 줄에서</small></h2>
        <p class="pd-chassis">SKU <span class="mono">${detail.option_part === null ? '—' : escapeHtml(detail.option_part)}</span></p>
      </section>`;
    const row = (item: ProductItemView, index: number): string => `
      <tr>
        ${rowNoCell(0, index)}
        <td class="pl-main mono"><b>${item.option_part === null ? '—' : escapeHtml(item.option_part)}</b></td>
        <td class="pl-sub">${escapeHtml(item.item_category)}</td>
        <td class="pl-main pl-desc"><div class="pl-clamp">${item.description === null ? '<span class="text-muted">설명 없음</span>' : escapeHtml(item.description)}</div></td>
        <td class="pl-main pl-qty"><span class="mono">${item.quantity}</span></td>
        <td class="pl-sub pl-id">${item.hclt_product_id === null || item.hclt_number === null ? '—' : `<a class="mono" data-link href="/products/${escapeHtml(item.hclt_product_id)}" target="_blank">${escapeHtml(item.hclt_number)}</a>`}</td>
      </tr>`;
    return `
      <section class="form-card pd-card">
        <h2>구성 <small>묶음의 파트 product · 수량</small></h2>
        ${detail.items.length === 0
          ? '<p class="text-muted">구성 줄이 없습니다</p>'
          : `<table class="pv-table pv-po"><thead><tr>${ROW_NO_HEAD}<th>파트넘버</th><th>품목</th><th>설명</th><th>수량</th><th>파트 제품</th></tr></thead><tbody>${detail.items.map((item, index) => row(item, index)).join('')}</tbody></table>`}
      </section>`;
  }

  /** 재고 요약 — 총합 한 칸 + 그 안의 갈래 다섯(가용 · 세팅됨 · 검수 중 · 임대 · 자산). 한글 밑에 상태 코드(영어). 합산 표는 재고 현황의 몫 */
  private renderStock(detail: ProductDetail): string {
    const rows = this.data.units === null ? [] : this.data.units.rows;
    const summary = summarizeStock(rows);
    const tile = (word: string, code: string, count: number, extraClass: string): string =>
      `<div class="pd-tile ${extraClass}"><span class="pd-tile-n mono">${count}</span><span class="pd-tile-w">${word} <span class="pd-tile-code">${code}</span></span></div>`;
    return `
      <section class="form-card pd-card">
        <h2>재고 <small>실물 줄에서 센 수 — 총합 = 가용 + 세팅됨 + 검수 중 + 임대 + 자산. 컨디션 · 창고별은 재고 현황</small></h2>
        <div class="pd-tiles">
          ${tile('총합', 'total', summary.total, 'is-total')}
          ${tile('가용', 'available', summary.available, '')}
          ${tile('세팅됨', 'reserved', summary.reserved, '')}
          ${tile('검수 중', 'inspecting', summary.inspecting, '')}
          ${tile('임대', 'rented', summary.rented, '')}
          ${tile('자산', 'asset', summary.asset, '')}
        </div>
        <a class="pd-link" data-link href="${INVENTORY_HREF}?product_id=${encodeURIComponent(detail.id)}">재고 현황에서 작업 →</a>
      </section>`;
  }

  /** 메모 — 우리가 파는 단위의 사정. 수정 중이면 textarea([수정] 하나가 기본 정보와 같이 연다) */
  private renderNotes(detail: ProductDetail): string {
    const edit = this.data.edit;
    const body = edit === null
      ? (detail.notes === null || detail.notes.trim() === '' ? '<p class="text-muted">메모 없음</p>' : `<p class="pd-notes">${escapeHtml(detail.notes)}</p>`)
      : `<textarea class="pd-input pd-textarea" data-action="field" data-key="notes" rows="4" placeholder="단종, 대체는 P00924">${escapeHtml(edit.notes)}</textarea>`;
    return `
      <section class="form-card pd-card${edit === null ? '' : ' pd-editing'}">
        <h2>메모 <small>파는 단위의 사정(단종 · 대체). PN 의 사실은 카탈로그 메모, 한 장의 일은 실물 메모</small></h2>
        ${body}
      </section>`;
  }

  // ─── 핸들러 — 수정 ───
  /** [수정] — 지금 값으로 폼을 연다 */
  handleEdit(): void {
    const detail = this.data.detail;
    assert(detail !== null, '[수정] 은 상세가 온 뒤에만 보인다');
    this.data = { ...this.data, edit: editFormOf(detail), saveError: '', pnCheck: { kind: 'same' } };
    this.refreshRegion('.pv-body', () => this.renderBody());
  }

  /** [취소] — 폼을 버리고 읽기로 */
  handleCancel(): void {
    this.data = { ...this.data, edit: null, saveError: '', pnCheck: { kind: 'same' } };
    this.refreshRegion('.pv-body', () => this.renderBody());
  }

  /** 입력 한 칸 — 폼의 그 키만 바꾼다(다시 그리지 않는다 — 커서가 안 튄다) */
  handleField(_e: Event, el: HTMLElement): void {
    const edit = this.data.edit;
    if (edit === null) return;
    const key = el.dataset.key;
    const value = (el as HTMLInputElement).value;
    if (key === 'description') { edit.description = value; return; }
    if (key === 'notes') { edit.notes = value; return; }
    if (key === 'search_text') { edit.search_text = value; return; }
    if (key === 'spec_category') { edit.spec_category = value; return; }
    if (key === 'vendor') { edit.vendor = value; return; }
    if (key === 'spare_part') { edit.spare_part = value; return; }
    if (key === 'assembly_part') { edit.assembly_part = value; return; }
  }

  /** PN 칸 입력 — 폼만 바꾼다(다시 그리지 않는다). 조회 결과는 칸을 벗어날 때 다시 묻는다 */
  handlePnInput(_e: Event, el: HTMLElement): void {
    const edit = this.data.edit;
    if (edit === null) return;
    edit.option_part = (el as HTMLInputElement).value;
  }

  /** 제조사 셀렉트 — 목록의 것이면 그 글, '기타' 면 글 칸을 열고(비움) 사람이 친다 */
  handleVendorChoice(_e: Event, el: HTMLElement): void {
    const edit = this.data.edit;
    if (edit === null) return;
    const value = (el as HTMLSelectElement).value;
    edit.vendor = value === VENDOR_OTHER ? '' : value;
    this.refreshRegion('.pd-vendor-cell', () => renderVendorCell(edit.vendor, value === VENDOR_OTHER));
  }

  /** 번호 종류 — 폼만 바꾸고 다시 묻는다(종류가 다르면 찾는 열이 다르다) */
  handlePnKind(_e: Event, el: HTMLElement): void {
    const edit = this.data.edit;
    if (edit === null) return;
    const kind = E_PART_NUMBER_KINDS.find((candidate) => candidate === (el as HTMLSelectElement).value);
    assert(kind !== undefined, `번호 종류 셀렉트의 값은 E_PART_NUMBER_KINDS 중 하나 — renderPnCell 이 그렸다: ${(el as HTMLSelectElement).value}`);
    edit.pn_kind = kind;
    void this.handlePnCheck();
  }

  /** PN 칸을 벗어남 — 지금 PN 과 다르면(옵션 종류일 때만 같을 수 있다) 서버에 묻는다(같은 번호 제품 · 카탈로그). 결과는 칸 밑 한 줄 */
  async handlePnCheck(): Promise<void> {
    const edit = this.data.edit;
    const detail = this.data.detail;
    if (edit === null || detail === null) return;
    const pn = edit.option_part.trim();
    if (pn === '' || isSameNumber(edit, detail)) { this.setPnCheck({ kind: 'same' }); return; }
    this.setPnCheck({ kind: 'checking' });
    try {
      const lookup = await api.fetchProductLookup(pn);
      if (this.data.edit === null || this.data.edit.option_part.trim() !== pn || this.data.edit.pn_kind !== edit.pn_kind) return;
      const bSameColumn = lookup.matched_column === edit.pn_kind;   // 정정 저장(PUT)은 고른 종류의 칸으로만 찾는다 — 그 칸에 맞았을 때만 "연결됩니다"(2026-10-29 찾기는 칸 넷)
      const catalog = lookup.catalog === null || !bSameColumn ? null : { description: lookup.catalog.description, option_part: lookup.catalog.option_part };
      this.setPnCheck(pnCheckOf(lookup.product, catalog, this.data.id, edit.pn_kind));
    } catch (e) {
      this.setPnCheck({ kind: 'failed', message: e instanceof Error ? e.message : String(e) });
    }
  }

  private setPnCheck(pnCheck: PnCheck): void {
    this.data = { ...this.data, pnCheck };
    this.refreshRegion('.pd-pn-hint', () => renderPnCheck(pnCheck));
  }

  /** [저장] — PUT 한 번, 돌아온 상세로 읽기 상태 */
  async handleSave(): Promise<void> {
    const edit = this.data.edit;
    assert(edit !== null, '[저장] 은 수정 중에만 보인다');
    assert(this.data.detail !== null, '수정은 상세가 있을 때만');
    const input = saveInputOf(edit, this.data.detail.is_active, isSpecsOpen(this.data.detail));
    const pnProblem = pnProblemOf(edit, this.data.detail, this.data.pnCheck);
    if (pnProblem !== null) {
      this.data = { ...this.data, saveError: pnProblem };
      this.refreshRegion('.pv-body', () => this.renderBody());
      return;
    }
    const pn = edit.option_part.trim();
    const bPnChanged = this.data.detail.type === 'part' && this.data.detail.catalog !== 'linked' && pn !== '' && !isSameNumber(edit, this.data.detail);
    this.data = { ...this.data, saving: true, saveError: '' };
    this.refreshRegion('.pv-body', () => this.renderBody());
    try {
      const afterPn = bPnChanged ? await api.updateProductPartNumber(this.data.id, pn, edit.pn_kind) : null;   // PN 먼저 — 연결되면 서버가 카테고리 · 빈 설명을 카탈로그 것으로 채운다
      const detail = await api.updateProduct(this.data.id, afterPn === null ? input : inputAfterPnChange(input, afterPn));
      this.data = { ...this.data, detail, edit: null, saving: false, pnCheck: { kind: 'same' } };
    } catch (e) {
      const pnCheck: PnCheck = e instanceof api.ProductConflictError ? { kind: 'taken', product: e.product } : this.data.pnCheck;   // 저장 사이에 같은 PN 제품이 생겼으면(409 의 짝) taken 줄로
      this.data = { ...this.data, saving: false, pnCheck, saveError: e instanceof Error ? e.message : String(e) };
    }
    this.refreshRegion('.pv-body', () => this.renderBody());
  }

  /** PN 정정의 겹침 — 같은 PN 의 제품(남음)으로 이 제품(없어짐)을 합친다. 합쳤으면 남은 제품 상세로 옮겨 간다(이 제품은 닫혔다) */
  async handlePnMerge(): Promise<void> {
    const pnCheck = this.data.pnCheck;
    assert(pnCheck.kind === 'taken', '[합치기] 는 같은 PN 의 제품이 있을 때만 그려진다 — renderPnCheck 의 taken');
    const detail = await openMergeDialog(pnCheck.product.id, this.data.id, 'pn_change');
    if (detail === null) return;   // 취소
    window.location.assign(`/products/${encodeURIComponent(detail.id)}`);
  }

  /** 사용 여부 라디오 — 읽기 화면에서 바로 저장. 다른 칸은 지금 값 그대로 보낸다 */
  async handleActive(_e: Event, el: HTMLElement): Promise<void> {
    const detail = this.data.detail;
    assert(detail !== null, '사용 여부 라디오는 상세가 있을 때만 그려진다');
    const bActive = (el as HTMLInputElement).value === 'true';
    if (bActive === detail.is_active) return;
    this.data = { ...this.data, saving: true, saveError: '' };
    this.refreshRegion('.pv-body', () => this.renderBody());
    try {
      const input = saveInputOf(editFormOf(detail), bActive, false);   // 라디오는 사용 여부만 — specs 는 안 건드린다(null)
      const saved = await api.updateProduct(this.data.id, input);
      this.data = { ...this.data, detail: saved, saving: false };
    } catch (e) {
      this.data = { ...this.data, saving: false, saveError: e instanceof Error ? e.message : String(e) };
    }
    this.refreshRegion('.pv-body', () => this.renderBody());
  }

  /** 히스토리 — 표에 남은 넷(등록 · 승격 · 합침 · 견적) 최신순. 제품 칸 수정은 안 남는다(2026-10-20) */
  private renderHistory(detail: ProductDetail): string {
    return `
      <section class="form-card pd-card">
        <h2>히스토리 <small>등록 · 카탈로그 승격 · 합침 · 견적 — 칸 수정은 안 남습니다</small></h2>
        ${detail.history.map(renderHistoryLine).join('')}
      </section>`;
  }

}

/** 히스토리 한 줄 — 날짜 · 글(견적은 링크) · 사람(있으면) */
function renderHistoryLine(entry: ProductHistoryEntry): string {
  const text = entry.href === null ? escapeHtml(entry.text) : `<a data-link href="${escapeHtml(entry.href)}">${escapeHtml(entry.text)}</a>`;
  const who = entry.who === null ? '' : ` · ${escapeHtml(entry.who)}`;
  return `<div class="kv-row"><span class="kv-key mono">${escapeHtml(entry.at.slice(0, 10))}</span><span class="kv-val">${text}${who}</span></div>`;
}

/** 사용 여부 라디오 둘 — 읽기 화면의 칸. 저장 중엔 잠근다 */
function renderActiveRadios(bActive: boolean, bSaving: boolean): string {
  const disabled = bSaving ? 'disabled' : '';
  return `<span class="pd-radios">
    <label><input type="radio" name="is_active" data-action="active" value="true" ${bActive ? 'checked' : ''} ${disabled}> 사용</label>
    <label><input type="radio" name="is_active" data-action="active" value="false" ${bActive ? '' : 'checked'} ${disabled}> 단종 · 숨김</label>
  </span>`;
}

/** 상세 → 수정 폼(글만). null 칸은 '' */
function editFormOf(detail: ProductDetail): EditForm {
  return {
    option_part: detail.option_part ?? '',
    pn_kind: 'option_part',
    description: detail.description ?? '',
    notes: detail.notes ?? '',
    search_text: detail.search_text ?? '',
    spec_category: detail.spec_category ?? '',
    spare_part: detail.spare_part ?? '',       // 미연결 파트면 specs 의 값(서버가 카탈로그 없을 때 specs 를 준다)
    assembly_part: detail.assembly_part ?? '',
    vendor: detail.vendor ?? '',
  };
}

/** 제조사 칸 — 셀렉트(후보 + 기타). 지금 글이 후보 밖이거나 '기타' 를 골랐으면 글 칸이 같이 열린다 */
function renderVendorCell(vendor: string, bOtherChosen: boolean = false): string {
  const bKnown = VENDOR_CHOICES.includes(vendor);
  const bOther = bOtherChosen || (!bKnown && vendor !== '');
  const current = bOther ? VENDOR_OTHER : vendor;
  const options = ['', ...VENDOR_CHOICES].map((choice) => `<option value="${escapeHtml(choice)}" ${current === choice ? 'selected' : ''}>${choice === '' ? '—' : escapeHtml(choice)}</option>`).join('')
    + `<option value="${VENDOR_OTHER}" ${current === VENDOR_OTHER ? 'selected' : ''}>기타 — 직접 적기</option>`;
  const input = bOther ? `<input type="text" class="pd-input" data-action="field" data-key="vendor" value="${escapeHtml(vendor)}" placeholder="제조사 이름 — 카탈로그 철자대로">` : '';
  return `<span class="pd-pn-kind"><select class="pd-input pd-input-short" data-action="vendor-choice">${options}</select>${input}</span>`;
}

/** 폼의 번호가 지금 번호와 같은가 — 옵션 종류면 option_part 와, 스페어 · 어셈블리면 그 specs 값과(연결 안 된 파트의 칸) */
function isSameNumber(edit: EditForm, detail: ProductDetail): boolean {
  const pn = edit.option_part.trim();
  if (edit.pn_kind === 'option_part') return isSamePn(pn, detail.option_part);
  const current = edit.pn_kind === 'spare_part' ? detail.spare_part : detail.assembly_part;
  return detail.option_part === null && isSamePn(pn, current);
}

/** 미연결 파트인가 — 카탈로그가 줄 값(제조사 · 스페어 · 어셈블리)이 없어 사람이 specs 에 적는다 */
function isSpecsOpen(detail: ProductDetail): boolean {
  return detail.type === 'part' && detail.catalog !== 'linked';
}

/** 같은 PN 인가 — 서버의 PN 열쇠와 같은 규칙(trim · 공백 하나 · 대문자) */
function isSamePn(text: string, currentOrNull: string | null): boolean {
  if (currentOrNull === null) return false;
  const keyOf = (pn: string): string => pn.trim().replace(PN_KEY_PATTERN, ' ').toUpperCase();
  return keyOf(text) === keyOf(currentOrNull);
}

/** 조회 결과 → 칸 밑 한 줄. 같은 PN 의 제품이 이 제품이면(대소문자만 다른 경우) 다른 제품이 아니다 */
function pnCheckOf(productOrNull: ProductRef | null, catalogOrNull: { description: string | null; option_part: string } | null, selfId: string, kind: EPartNumberKind): PnCheck {
  if (productOrNull !== null && productOrNull.id !== selfId) return { kind: 'taken', product: productOrNull };
  if (catalogOrNull !== null) return { kind: 'link', description: catalogOrNull.description, option_part: kind === 'option_part' ? null : catalogOrNull.option_part };
  return { kind: 'request' };
}

function renderPnCheck(pnCheck: PnCheck): string {
  switch (pnCheck.kind) {
    case 'same': return '';
    case 'checking': return '<small class="text-muted">찾는 중…</small>';
    case 'taken': return `<small class="pc-error">같은 파트넘버의 제품이 있습니다 — <a class="mono" data-link href="/products/${escapeHtml(pnCheck.product.id)}" target="_blank" rel="noopener">${escapeHtml(pnCheck.product.hclt_number)}</a>. 저장할 수 없습니다 — 같은 물건이면 <button type="button" class="mg-number-link" data-action="pn-merge">확인하고 정리하기</button></small>`;
    case 'link': return `<small class="text-muted">카탈로그에 있습니다 — 저장하면 ${pnCheck.option_part === null ? '' : `옵션 <span class="mono">${escapeHtml(pnCheck.option_part)}</span> 로 `}연결됩니다${pnCheck.description === null ? '' : ` (${escapeHtml(pnCheck.description)})`}</small>`;
    case 'request': return '<small class="text-muted">카탈로그에 없습니다 — 저장하면 새로 요청이 나갑니다(옛 요청은 닫힙니다). 스페어 · 어셈블리면 옵션 PN 은 비고 그 번호가 제품에 남습니다. 번호는 대문자 · 공백 하나로 저장됩니다</small>';
    case 'failed': return `<small class="pc-error">조회하지 못했습니다 — ${escapeHtml(pnCheck.message)}</small>`;
    default: {
      const never: never = pnCheck;
      throw new Error(`unhandled PnCheck: ${JSON.stringify(never)}`);
    }
  }
}

/** PN 정정 뒤의 수정 입력 — 연결됐으면 카테고리 · 설명은 카탈로그 것(서버가 이미 덮었다, 2026-10-22 잠금)이고
 *  스페어 · 어셈블리 · 제조사 칸은 안 보낸다(카탈로그가 준다). 안 이어졌으면 폼 설명이 비었을 때만 서버가 채운 것을 지킨다 */
function inputAfterPnChange(input: ProductUpdateInput, afterPn: ProductDetail): ProductUpdateInput {
  if (afterPn.catalog === 'linked') {
    return { ...input, spec_category: afterPn.spec_category, description: afterPn.description ?? '', specs_text: null };
  }
  const description = input.description.trim() === '' && afterPn.description !== null ? afterPn.description : input.description;
  return { ...input, description };
}

/** 저장 전에 막을 PN 문제 — 빈 칸 · 같은 PN 제품 있음. 없으면 null. 연결된 파트 · 서버 · 세트는 칸이 없어 문제도 없다 */
function pnProblemOf(edit: EditForm, detail: ProductDetail, pnCheck: PnCheck): string | null {
  if (detail.type !== 'part' || detail.catalog === 'linked') return null;
  if (edit.option_part.trim() === '' && detail.option_part !== null) return PN_EMPTY_WORD;
  if (pnCheck.kind === 'taken') return PN_TAKEN_WORD;
  return null;
}

/** 폼 → 보낼 입력. 안전재고는 재고 › 실사 · 설정에서(2026-10-19) */
function saveInputOf(edit: EditForm, bActive: boolean, bSpecsOpen: boolean): ProductUpdateInput {
  return {
    description: edit.description,
    notes: edit.notes,
    search_text: edit.search_text,
    spec_category: edit.spec_category === '' ? null : edit.spec_category,
    is_active: bActive,
    specs_text: bSpecsOpen ? { spare_part: edit.spare_part, assembly_part: edit.assembly_part, vendor: edit.vendor } : null,
  };
}

/** 실물 줄 → 요약 수. 출고 · 이탈은 목록에 안 오고(show_gone false) 와도 안 센다 — 없는 것이다. 총합 = 갈래 다섯의 합 */
export function summarizeStock(rows: readonly UnitView[]): StockSummary {
  const summary: StockSummary = { total: 0, available: 0, reserved: 0, inspecting: 0, rented: 0, asset: 0 };
  for (const unit of rows) {
    if (unit.stock_status === 'available') summary.available += 1;
    else if (unit.stock_status === 'reserved') summary.reserved += 1;
    else if (unit.stock_status === 'inspecting') summary.inspecting += 1;
    else if (unit.stock_status === 'rented') summary.rented += 1;
    else if (unit.stock_status === 'asset') summary.asset += 1;
  }
  summary.total = summary.available + summary.reserved + summary.inspecting + summary.rented + summary.asset;
  return summary;
}
